import { limitMoreZero } from '@/utils/validate'
import { thousandSeparatorReplace } from '@/framework/directive/index.js'
import { FEE_CODE_MAP } from '@/store/dict/rentPlanDict.js'
import CustomerNameOptionItem from '@/components/CustomerSelect/optionItem'

const amountRules = (rule, value, callback) => {
  limitMoreZero(value, (data) => {
    if (Number(data) === 0) {
      callback(new Error('金额不能为0'))
    } else {
      callback()
    }
  })
}
// 应收校验规则
const receivableRules = {
  content: [{ required: true, message: '应收内容不能为空', trigger: 'change' }],
  receivableDate: [
    { required: true, message: '应收日期不能为空', trigger: 'change' },
  ],
  receivableAmount: [
    { required: true, message: '金额不能为空', trigger: 'change' },
    { validator: amountRules, trigger: 'change' },
  ],
  carId: [{ required: true, message: '车牌号不能为空', trigger: 'change' }],
  customerType: [
    { required: true, message: '付款方类型不能为空', trigger: 'change' },
  ],
  customerId: [
    { required: true, message: '付款方不能为空', trigger: 'change' },
  ],
  sourceOrderType: [
    { required: true, message: '来源类型不能为空', trigger: 'change' },
  ],
  sourceOrderId: [
    { required: true, message: '来源单号不能为空', trigger: 'change' },
  ],
}
const config = function () {
  return {
    receivableList: [
      {
        el: 'select',
        itemConfig: {
          label: '应收内容',
          prop: 'content',
        },
        elConfig: {
          placeholder: '请选择应收内容',
          disabled: false,
          options: {
            label: 'name',
            value: 'code',
            list: this.freeTypeList,
          },
          events: {
            change: (val) => {
              // 选滞纳金时14，自动往备注里填充默认值
              const remarksValue =
                val === FEE_CODE_MAP.ZHI_NA_JIN ? '手动创建' : ''
              this.modifiedRemarks(remarksValue)
            },
          },
        },
      },
      {
        el: 'date-picker',
        itemConfig: {
          label: '应收日期',
          prop: 'receivableDate',
        },
        elConfig: {
          type: 'date',
          placeholder: '选择应收日期',
          'value-format': 'yyyy-MM-dd',
          'default-time': '',
          'default-value': '',
        },
      },
      {
        el: 'input',
        itemConfig: {
          label: '应收金额',
          prop: 'receivableAmount',
        },
        elConfig: {
          placeholder: '请输入应收金额',
          maxlength: '13',
          slotRender: (createElement) => {
            return createElement('template', { slot: 'append' }, '元')
          },
          events: {
            input: (value) => {
              const result = thousandSeparatorReplace(value)
              this.model.receivableAmount = result
            },
          },
        },
      },
      {
        el: 'CarSelect',
        itemConfig: {
          label: '车牌号',
          prop: 'carId',
        },
        elConfig: {
          render: 'CarSelect',
          getCarDetail: false,
          events: {
            change: (val) => this.carNoChange(val),
          },
        },
      },
      {
        el: 'select',
        itemConfig: {
          label: '付款方类型',
          prop: 'customerType',
        },
        elConfig: {
          placeholder: '请选择付款方类型',
          options: {
            label: 'label',
            value: 'value',
            list: [],
          },
          events: {
            change: (val) => this.payableType(val),
          },
        },
      },
      {
        el: 'select',
        itemConfig: {
          label: '付款方',
          prop: 'customerId',
        },
        elConfig: {
          placeholder: '请输入',
          disabled: true,
          options: {
            label: 'customerName',
            value: 'id',
            list: [],
          },
          jsxRender: (option) => {
            return <CustomerNameOptionItem data={option} />
          },
          filterable: true,
          remote: this.mode?.customerType === 2,
          clearable: true,
          'reserve-keyword': true,
          'remote-method': this.getPayCustomerList,
          // 新增监听 付款方数据变更事件
          events: {
            change: (val) => this.handleCustomerIdChange(val),
          },
        },
      },
      {
        el: 'select',
        itemConfig: {
          label: '来源类型',
          prop: 'sourceOrderType',
        },
        elConfig: {
          placeholder: '请选择来源类型',
          disabled: true,
          options: {
            label: 'label',
            value: 'value',
            list: [],
          },
          events: {
            change: (val) => this.sourceOrderTypeChange(val),
          },
        },
      },
      {
        el: 'select',
        itemConfig: {
          label: '来源单号',
          prop: 'sourceOrderId',
        },
        elConfig: {
          placeholder: '请选择来源单号',
          disabled: true,
          options: {
            list: [],
          },
        },
      },
      {
        el: 'input',
        itemConfig: {
          label: '备注',
          prop: 'remarks',
          type: 'textarea',
        },
        elConfig: {
          placeholder: '请输入备注',
          type: 'textarea',
          maxlength: 500,
          showWordLimit: true,
        },
      },
    ],
    payableList: [
      {
        el: 'select',
        itemConfig: {
          label: '应付内容',
          prop: 'payType',
        },
        elConfig: {
          disabled: false,
          options: {
            label: 'name',
            value: 'id',
            list: [],
          },
        },
      },
      {
        el: 'date-picker',
        itemConfig: {
          label: '应付日期',
          prop: 'payDate',
        },
      },
      {
        el: 'input',
        itemConfig: {
          label: '应付金额',
          prop: 'payAmount',
        },
      },
      {
        el: 'input',
        itemConfig: {
          label: '车牌号',
          prop: 'carId',
        },
      },
      {
        el: 'select',
        itemConfig: {
          label: '收款方类型',
          prop: 'payeeType',
        },
        elConfig: {
          disabled: false,
          options: {
            label: 'name',
            value: 'id',
            list: [],
          },
        },
      },
      {
        el: 'select',
        itemConfig: {
          label: '收款方',
          prop: 'payeeId',
        },
        elConfig: {
          disabled: false,
          options: {
            label: 'name',
            value: 'id',
            list: [],
          },
        },
      },
      {
        el: 'select',
        itemConfig: {
          label: '来源类型',
          prop: 'sourceOrderType',
        },
        elConfig: {
          disabled: false,
          options: {
            label: 'name',
            value: 'id',
            list: [],
          },
        },
      },
      {
        el: 'select',
        itemConfig: {
          label: '来源单号',
          prop: 'sourceOrderId',
        },
        elConfig: {
          disabled: false,
          options: {
            label: 'name',
            value: 'id',
            list: [],
          },
        },
      },
      {
        el: 'input',
        itemConfig: {
          label: '备注',
          prop: 'remarks',
          type: 'textarea',
        },
        elConfig: {
          type: 'textarea',
          maxlength: 500,
          showWordLimit: true,
        },
      },
    ],
    receivableRules,
  }
}

export default config
